<template>
  <!--    CREATE   -->
  <sweet-modal
    ref="create-popup"
    :title="`${ $t('ct-create-new-popup')}`"
    class="sweet-modal-theme-cheetah"
    width="35%"
    hide-close-button
    blocking
  >
    <form>
      <div class="form-group">
        <label :for="`name-popup`">{{ $t('ct-name')}}</label>
        <input
          class="form-control"
          v-model="item.name"
          name="name"
          :id="`name-popup`"
          maxlength="255"
          :class="{ 'is-invalid': errors.has('item.name')}"
          @keyup="errors.clear('item.name')"
          required
        />
        <span
          v-if="errors.has('item.name')"
          class="invalid-feedback"
          v-text="errors.get('item.name')"
        ></span>
      </div>
    </form>
    <button
      slot="button"
      class="btn btn-outline-light"
      @click.prevent="close"
    >{{ $t('ct-cancel')}}
    </button>
    <button slot="button" class="btn btn-success" @click="createPopUp"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {setPageConfig} from '../../../js/services/editor/configManager';
import {create as createPopup} from '../../../js/services/editor/popups';

import {get} from '../../../js/services/editor/layout';
import Errors from '../../../js/base/Errors';

export default {
  name: 'CreatePopUp',
  props: ['popups', 'layout_id', 'page_id'],
  components: {
    SweetModal
  },
  data() {
    return {
      errors: new Errors(),
      item: {
        name: '',
        layout_id: null
      }
    };
  },
  methods: {
    open() {
      this.$refs['create-popup'].open();
    },
    close() {
      this.empty();
      this.$refs['create-popup'].close();
    },

    empty() {
      this.item = {
        name: '',
        layout_id: this.layout_id
      };
      this.errors.clear();
    },
    updateList() {
      this.$loading.show();

      get(this.layout_id).then(response => {
        this.$emit('updatePopups', response.data['popups']);
      })
        .finally(() => this.$loading.hide());
    },

    createPopUp() {
      this.item.layout_id = this.layout_id;

      this.$loading.show();
      if (!this.errors.any()) {
        createPopup(this.item).then(res => {
          this.updateList();
        }).finally(() => {
          this.$loading.hide();
          this.close();
        });
      }
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/base/CreatePopUp.vue